// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2AIrf","title":"ClientReferral_title__1U1QH","itemText":"ClientReferral_itemText__3eGVu"};